<template>
	<div v-if="summary != null" class="map-tooltip-style vrs-accuracy-summary-position">
		<VerticalLayout size="small">
			<TypographyText strong>{{ summary.title }}</TypographyText>
			<Descriptions class="vrs-summary-descriptions" :column="1" size="small" :colon="false" :bordered="true">
				<DescriptionsItem :label="$t('home-map.vrsAccuracySummary.totalStations')">
					{{ summary.total }}
				</DescriptionsItem>
				<DescriptionsItem :label="$t('home-map.vrsAccuracySummary.inSolution')">
					{{ summary.inSolution }}
				</DescriptionsItem>
			</Descriptions>
			<div>
				<GnssTag
					v-for="badge in summary.gnssBadges"
					:key="badge.code"
					:code="badge.code"
					:forceGrey="badge.forceGrey"
				/>
			</div>
			<div v-if="summary.coverageCalculatedAt" class="updated-datetime">
				{{ $t('home-map.vrsAccuracySummary.coverageUpd') }}
				<DateTimeDisplay :date="summary.coverageCalculatedAt" />
			</div>
			<div class="updated-datetime">
				{{ $t('home-map.vrsAccuracySummary.residualsUpd') }}
				<DateTimeDisplay :date="summary.residualsUpdatedAt" />
			</div>
		</VerticalLayout>
	</div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { TypographyText, Descriptions, DescriptionsItem } from 'ant-design-vue';

import Consts from '@/api/Consts';

import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import GnssTag from '@/components/common/GnssTag';
import VerticalLayout from '@/components/common/VerticalLayout';
import type { SubNetworkSummary } from '@/components/map/tooltips/vrsAccuracyMetricsUtils';

export default {
	components: {
		TypographyText,
		Descriptions,
		DescriptionsItem,
		GnssTag,
		DateTimeDisplay,
		VerticalLayout,
	},
	props: {
		summary: {
			type: Object as PropType<SubNetworkSummary | null>,
			required: false,
			default: null,
			validator: (value: SubNetworkSummary | null) => value == null || ['id', 'title', 'total', 'inSolution', 'gnssBadges'].every(key => key in value),
		},
	},
	setup() {
		return {
			gray: Consts.COLORS.gray,
		};
	},
};
</script>

<style scoped>
@import '@/assets/map-legend.css';

.vrs-accuracy-summary-position {
	padding: 8px 16px;
	inset-block-end: 40px;
	inset-inline-start: 50%;
	transform: translateX(-50%);
	max-width: 90%;
}

.updated-datetime {
	white-space: nowrap;
	font-size: 9px;
	color: v-bind(gray);
}

</style>

<style>
.vrs-summary-descriptions.ant-descriptions .ant-descriptions-row > th,
.vrs-summary-descriptions.ant-descriptions .ant-descriptions-row > td {
	padding: 2px 8px;
}

.vrs-summary-descriptions.ant-descriptions .ant-descriptions-item-content {
	text-align: end;
}
</style>
